import React, { useMemo } from 'react'

import currencyFormatter from '../utils/currencyFormatter'

import * as styles from './PaymentSummaryTable.m.css'

type Props = {
  invoices: Invoice[]
  portalFeeAmount: number
  showSubtotals: boolean
}

const PaymentSummaryTable: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { invoices, portalFeeAmount, showSubtotals } = props

  const total = useMemo(() => {
    return invoices.reduce((acc, i) => acc + i.remainingBalance, 0)
  }, [invoices])

  return (
    <table>
      <thead>
        <tr>
          <th>Invoice Number</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {invoices.map((invoice) => (
          <tr key={invoice.rid}>
            <td>{invoice.invoiceId}</td>
            <td className={styles.amountCell}>
              {currencyFormatter.format(invoice.remainingBalance)}
            </td>
          </tr>
        ))}
        {showSubtotals ? (
          <>
            <tr>
              <td>Subtotal</td>
              <td className={styles.totalCell}>
                {currencyFormatter.format(total)}
              </td>
            </tr>
            <tr>
              <td>Portal Fee</td>
              <td className={styles.totalCell}>
                {currencyFormatter.format(portalFeeAmount)}
              </td>
            </tr>
          </>
        ) : null}
        <tr>
          <td>Total</td>
          <td className={styles.totalCell}>
            {showSubtotals
              ? currencyFormatter.format(total + portalFeeAmount)
              : currencyFormatter.format(total)}
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default PaymentSummaryTable
